module.exports = __webpack_public_path__ + "static/16.8_Later_Middle_Ages-f7bbda793f0bf47e47465ef7f3a476dd.pdf";